// GET

import axios, { AxiosResponse } from 'axios';
import { PutSiloBufferRequest } from 'views/site-settings/features/inventory-silo-management/types/put-silo-buffer-request.type';
import { PutSiloSettingsRequest } from 'views/site-settings/features/inventory-silo-management/types/put-silo-settings-request.type';
import { UpdateSiloManagement } from 'views/site-settings/features/inventory-silo-management/types/silo-management-form.type';
import { SiloManagement } from 'views/site-settings/features/inventory-silo-management/types/silo-management.type';
import { PutSiteComment } from '../types/put-site-comment.type';
import { Silos } from '../mock/silo-list.mock';

// /ewosapi/v1/silo-management/{globalSiteId}/silos
export const getManagementSilos = async (globalSiteId: string): Promise<SiloManagement[]> => {
  const res = await axios.get<SiloManagement[]>(`/ewosapi/v1/silo-management/${globalSiteId}/silos`);
  return res.data;
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/silo
// Set site silo management settings
export const putManagementSilos = async (globalSiteId: string, request: UpdateSiloManagement): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/silo-management/${globalSiteId}/silos`, request);
};

// PUT
// /ewosapi/v1/silo-management/{globalSiteId}/silos/{siloId}?isEnabled=true
// Set site silo management settings
export const putDisableSilo = async (globalSiteId: string, siloId: string, status: boolean): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/silo-management/${globalSiteId}/silos/${siloId}?isEnabled=${status}`);
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/silo
// Set site silo settings
export const putSiloSettings = async (globalSiteId: string, request: PutSiloSettingsRequest): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/silo`, request);
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/silo/fillpercentage
// Set site silo fill percentage
export const putSiloBuffer = async (globalSiteId: string, request: PutSiloBufferRequest): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/silo/fillpercentage`, request);
};

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/comment
// Set site silo comment to vessel
export const putSiteComment = async (globalSiteId: string, request: PutSiteComment): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/comment`, request);
};
